import React from 'react';
import { Link } from 'react-router-dom';
// IMPORT THE JSON HERE
import projectsData from '../data/projects.json'; 

const ProjectsPage = () => {
  return (
    <div className="bg-slate-50 min-h-screen">

      {/* ================= HERO SECTION ================= */}
      <section className="relative w-full h-[500px] md:h-[600px] flex items-center justify-center bg-slate-900">
        <img
          src="https://images.pexels.com/photos/20069743/pexels-photo-20069743.jpeg?_gl=1*1xjr7m5*_ga*NDIwOTEzMDMyLjE3NjkzNTY0Mjk.*_ga_8JE65Q40S6*czE3NzA2NzI5NTYkbzIkZzEkdDE3NzA2NzMxNzkkajUzJGwwJGgw"
          alt="Landscaping Hero"
          className="absolute inset-0 w-full h-full object-cover brightness-75"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent"></div>
        <div className="relative z-10 text-center px-4 max-w-3xl mx-auto">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-4">Galabau Palloshi</h1>
          <p className="text-lg md:text-xl text-emerald-200 leading-relaxed">
            Professionelle Landschaftsgestaltung, Gartenpflege und Bauprojekte – <br />
            von der Planung bis zur Umsetzung, alles aus einer Hand.
          </p>
        </div>
      </section>

      {/* ================= DESCRIPTION / INTRO ================= */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 text-center max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">Unsere Expertise</h2>
        <p className="text-slate-700 text-lg md:text-xl leading-relaxed">
          Wir kombinieren Kreativität, Erfahrung und handwerkliches Können, um Gärten und Außenanlagen
          in lebendige, nachhaltige und ästhetische Räume zu verwandeln. Vom Baumfällen und Heckenschnitt
          bis hin zu Holzterrassen und Pflasterarbeiten – wir kümmern uns um jedes Detail.
        </p>
      </section>

      {/* ================= PROJECTS GRID ================= */}
      <section className="py-20 px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {projectsData.map((project) => (
            <Link 
              key={project.id} 
              to={`/project/${project.id}`} 
              className="group relative h-[400px] w-full rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 ease-in-out cursor-pointer block"
            >
              {/* Image Background */}
              <img 
                src={project.image} 
                alt={project.title} 
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              
              {/* Dark Overlay Gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/40 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-300"></div>

              {/* Text Content */}
              <div className="absolute bottom-0 left-0 p-8 w-full translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
                <span className="text-emerald-400 text-xs font-bold uppercase tracking-widest mb-2 block">
                  {project.category}
                </span>
                <h2 className="text-2xl font-bold text-white mb-2 leading-tight">
                  {project.title}
                </h2>
                <p className="text-slate-300 text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100 line-clamp-2">
                  {project.shortDescription}
                </p>
                <div className="mt-4 flex items-center text-white text-sm font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-200">
                  View Project <span className="ml-2 text-xl">→</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* ================= CTA / FOOTER ================= */}
      <section className="py-16 bg-emerald-900 text-white text-center">
        <h3 className="text-3xl md:text-4xl font-bold mb-4">Bereit für Ihr Gartenprojekt?</h3>
        <p className="mb-8 text-emerald-100 max-w-2xl mx-auto">
          Kontaktieren Sie uns für eine kostenlose Beratung und ein individuelles Angebot. 
          Wir bringen Ihre Vision in die Realität.
        </p>
        <Link 
          to="/contact" 
          className="inline-block px-8 py-3 bg-white text-emerald-900 rounded-lg font-bold hover:bg-emerald-50 transition-colors"
        >
          Kontakt aufnehmen
        </Link>
      </section>

    </div>
  );
};

export default ProjectsPage;
